<template>
  <div class="lesson-detail">
    <ucar-title>{{lessonDetail.title || '加载中……'}}</ucar-title>
    <div class="lesson-detail-content" ref="pLessonDetailPage" style="-webkit-overflow-scrolling:touch">
      <div class="rich-text-iframe" v-if="lessonDetail.attachType == 3" ref="pLessonDetailRich">
        <!-- 富文本使用iframe -->
        <iframe :src="lessonDetail.attachUrl" frameborder="0" width="100%"></iframe>
      </div>
      <!-- 超链接使用iframe -->
      <iframe v-if="lessonDetail.attachType == 2" :src="lessonDetail.attachUrl" frameborder="0" width="100%"
              scrolling="auto" ref="pLessonDetailIframe"></iframe>
      <!-- pdf使用canvas -->
      <canvas v-if="lessonDetail.attachType == 1" class="pdf-content" ref="pLessonDetailCanvas"></canvas>
    </div>
    <div v-if="lessonDetail.attachType == 1" class="pager prev" @click="pdfPage('prev')">
    </div>
    <div v-if="lessonDetail.attachType == 1" class="pager next" @click="pdfPage('next')">
    </div>
    <div class="lesson-detail-footer">
      <ucar-button size="full" @click.native="joinExam">课后测试</ucar-button>
    </div>
  </div>  
</template>

<script>
import pdfjsLib from 'pdfjs-dist'
import workerSrc from 'pdfjs-dist/build/pdf.worker'
import { getLessDetail, queryExamStatus, LessonSyncRefresh } from '../../api'
import { studySyncTime } from '../../utils/constants'
import { iosXiumiHack } from '../../utils/hacks'

export default {
  data () {
    return {
      lessonDetail: {
        title: '',
        releaseTime: '',
        attachType: 1,
        firstClassName: '',
        secondClassName: '',
        learnedCount: '',
        attachUrl: '',
      },
      pageNo: 1,
      syncFn: null
    }
  },
  methods: {
    pdfRender (pdfPath, action) {
      this.$loading.show()
      // 上一页下一页操作
      const pager = {
        prev: () => {
          if (this.pageNo > 1) {
            this.pageNo--
            return true
          } else {
            return '已经到第一页了'
          }
        },
        next: (max) => {
          if (this.pageNo < max) {
            this.pageNo++
            return true
          } else {
            return '已经到最后一页了'
          }
        }
      }
      pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc
      const loadingTask = pdfjsLib.getDocument(pdfPath)
      loadingTask.promise.then(pdfDocument => {
        // 分页校验
        const pageRes = action ? pager[action](pdfDocument.numPages) : true
        if (typeof pageRes === 'string') {
          this.$alert(pageRes)
          this.$loading.hidden()
          return
        }
        // Request a first page
        return pdfDocument.getPage(this.pageNo).then(pdfPage => {
          // Display page on the existing canvas with 100% scale.
          const viewport = pdfPage.getViewport(1.0)
          const canvas = this.$refs.pLessonDetailCanvas
          canvas.width = viewport.width
          canvas.height = viewport.height
          const ctx = canvas.getContext('2d')
          const renderTask = pdfPage.render({
            canvasContext: ctx,
            viewport: viewport
          })
          this.$loading.hidden()
          return renderTask.promise
        })
      }).catch(reason => {
        this.$loading.hidden()
        console.error('Error: ' + reason)
      })
    },
    pdfPage (action) {
      this.pdfRender(this.lessonDetail.attachUrl, action)
    },
    joinExam () {
      //  未达到时间 alert 您还需学习xx分钟才可考试
      if (this.lessonDetail.needLearnMins > 0) {
        this.$alert(`您还需学习${this.lessonDetail.needLearnMins}分钟才可考试`)
        return
      }
      queryExamStatus({
        courseId: this.$route.params.id,
        relevanceId: this.vuexRecruitId
      })
        .then(data => {
          // 状态为-1 alert 您已通过了课程测试
          if (data.busiStatus === -1) {
            this.$alert(data.busiMsg)
            return
          }
          this.setVuexTrainExamData({...data, courseId: this.$route.params.id})
          this.$router.push('/exam-detail')
        })
    },
    getDetail () {
      getLessDetail({
        courseId: this.$route.params.id,
        relevanceId: this.vuexRecruitId
      })
        .then(data => {
          this.lessonDetail = data
          this.classify = this.lessonDetail.classify ? this.lessonDetail.classify.split(',') : []
          this.syncStudy()
          // 异步更新队列 用于修改布局
          this.$nextTick(_ => {
            this.lessonDetail.attachType * 1 === 1 && this.pdfRender(this.lessonDetail.attachUrl)
            this.lessonDetail.attachType * 1 === 2 && iosXiumiHack(this.$refs.pLessonDetailPage, this.$refs.pLessonDetailIframe)
          })
        })
    },
    syncStudy (stop) {
      if (stop) {
        clearInterval(this.syncFn)
        return
      }
      // 定时向后台同步
      this.syncFn = setInterval(_ => {
        // 剩余时间
        this.lessonDetail.needLearnMins -= studySyncTime / 60 // 单位分钟
        LessonSyncRefresh({
          type: 1,
          bindId: this.$route.params.id,
          relevanceId: this.vuexRecruitId,
          elapseSecs: studySyncTime
        })
          .then(data => {
          })
      }, studySyncTime * 1000)
    }
  },
  mounted () {
    this.getDetail()
  },
  beforeDestroy () {
    if (this.syncFn) {
      clearInterval(this.syncFn)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl'

.lesson-detail {
  display: block;
  .lesson-detail-content {
    height: auto;
    position: absolute;
    -webkit-overflow-scrolling: touch;
    top: 88px;
    bottom: 148px;
    left: 0;
    right: 0;
    overflow-y: auto;
    font-size: 0;
    line-height: 0;

    iframe {
      min-height: 100%;
    }

    .rich-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      color: $ucar_font_color;
      line-height: 1.4;
      padding-bottom: 10px;

      .info-pane {
        padding: 50px 60px;
        background-color: #fff;
        h4 {
          margin-bottom: 20px;
        }
        .tag-box {
          ucar-utils-clearfix()
          min-height: 40px;
          margin-bottom: 20px;
          .tag + .tag {
            margin-left: 20px;
          }
        }
        p {
          color: $ucar_font_assist_color;
          .preview {
            float: right;
          }
        }
      }
    }
    .rich-text-iframe {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      position: absolute;
      height: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .pager {
    position: absolute;
    top: 45%;
    width: 60px;
    height: 120px;
    background-color: rgba(0,0,0,.3);
    &.prev{
      left: 0;
      &:before{
        position: absolute;
        top: 40px;
        left: 0;
        content: '';
        display: block;
        ucar-line-arrows(30px);
        border-left: 2px solid #fff;
        border-bottom: 2px solid #fff;
        transform-origin: 20px 20px;
        margin-left: 20px;
      }
    }
    &.next{
      right: 0;

      &:before{
        position: absolute;
        top: 40px;
        left: 0;
        content: '';
        display: block;
        ucar-line-arrows(30px);
        border-right: 2px solid #fff;
        border-top: 2px solid #fff;
        transform-origin: 20px 20px;
        margin-right: 20px;
      }
    }
  }

  .lesson-detail-footer {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 30px;
  }
}
</style>
